var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.40001 5.86676V5.25724C4.40001 3.2313 6.00573 1.6001 8.00001 1.6001C9.9943 1.6001 11.6 3.2313 11.6 5.25724V5.86676M4.40001 5.86676C3.74001 5.86676 3.20001 6.41534 3.20001 7.08581V13.181C3.20001 13.8515 3.74001 14.4001 4.40001 14.4001H11.6C12.26 14.4001 12.8 13.8515 12.8 13.181V7.08581C12.8 6.41534 12.26 5.86676 11.6 5.86676M4.40001 5.86676H11.6",
    stroke: "#455468",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/IconLock.c0c6219e8e34843c640cdf7685c50fff.svg";
export { ForwardRef as ReactComponent };